export default "../css/3bc838f2b33109bb6c2da010f9968a41.ttf";